import { isDevelopmentEnvironment } from "@/lib/env";

export let isPaymentConfigurationManagementEnabled = false;

// Criação/exclusão manual de condições de pagamento disponível somente em ambiente de Desenvolvimento (localhost/homologação).
// Comente a linha abaixo para desativar os botões de criar/excluir no frontend.
isPaymentConfigurationManagementEnabled = isDevelopmentEnvironment;
